import { CoreIcon } from '../core-icon';
import logoAutopassForBusinessSVG from '../../assets/logos/logo-autopass-for-business.svg';
import type { IconProps } from '../core-icon';

export const LogoAutopassForBusinessIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={logoAutopassForBusinessSVG} {...props} />;
};
